import React from "react";
import { Link } from "react-router-dom";
import handleAddToCart from "./addtocartfunction"; // Import the add to cart function
const ProductCard = ({
    id,
    name,
    image,
    badge,
    rating,
    ratingCount,
    sold,
    total,
    oldPrice,
    price,
}) => {
    const progress = Math.round((sold / total) * 100);

    return (
        <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
            <Link
                to={`/product-details/${id}`}
                className="product-card__thumb flex-center rounded-8  position-relative"
            >
                <img
                    src={image}
                    alt={name}
                    className="w-100 h-100 object-fit-cover rounded-8"
                />

                {badge && (
                    <span className="product-card__badge bg-primary-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                        {badge}
                    </span>
                )}
            </Link>

            <div className="product-card__content mt-16">
                <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link to={`/product-details/${id}`} className="link text-line-2">
                        {name}
                    </Link>
                </h6>

                <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">{rating}</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">({ratingCount})</span>
                </div>

                <div className="mt-8">
                    <div
                        className="progress w-100 bg-color-three rounded-pill h-4"
                        role="progressbar"
                        aria-valuenow={progress}
                        aria-valuemin={0}
                        aria-valuemax={100}
                    >
                        <div
                            className="progress-bar bg-main-two-600 rounded-pill"
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                        Sold: {sold}/{total}
                    </span>
                </div>

                <div className="product-card__price my-20">
                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                        {oldPrice}
                    </span>
                    <span className="text-heading text-md fw-semibold">
                        {price} <span className="text-gray-500 fw-normal">/Qty</span>
                    </span>
                </div>

                <button
                    onClick={() => handleAddToCart(id)}
                    className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                >
                    Add To Cart <i className="ph ph-shopping-cart" />
                </button>

                
            </div>
        </div>
    );
};

export default ProductCard;
